<template>
  <div class="form-group">
    <div v-if="resultView">
      <a href="#" @click.prevent="download">{{document.name}}&nbsp;<i class="fa" :class="{'fa-download': !working, 'fa-cog fa-spin': working}"></i></a>
    </div>
    <div v-else>
      <label class="col-sm-2 control-label">{{document.name}} <span v-if="document.required && canAdd" class="text-danger">*</span></label>
      <div class="col-sm-10">

        <div v-if="working">
          <img src="static/img/qc/spinner-qc.svg" style="width: 38px" />
        </div>
        <div v-else-if="uploaded">
          <button @click.prevent="download" class="btn btn-fill btn-default"><i class="fa fa-eye"></i>&nbsp;View</button>
          <button v-if="canDelete" @click.prevent="del" class="btn btn-default"><i class="fa fa-trash"></i>&nbsp;Delete</button><br/>
          {{document.filename}}
        </div>
        <div v-else-if="canAdd">
          <base64-uploader @data="upload" :name="document.name" :inError="errors.has('docs' + validationScope + '.' + document.name)" v-validate:uploaded="'requiredDoc'" :data-vv-scope="'docs' + validationScope"/>
          <button v-if="!document.required" @click.prevent="rm" class="btn btn-default"><i class="fa fa-trash"></i>&nbsp;Remove</button><br/>
        </div>
        <div v-else class="form-control-static">
          Missing! The request is likely to be rejected!
        </div>
        <small class="text-danger" v-show="errors.has('docs' + validationScope + '.' + document.name)">
          {{ errors.first('docs' + validationScope + '.' + document.name) }}
        </small>

        <span v-if="document.description" class="help-block">{{document.description}} {{document.templateDescription}} <a v-if="document.template" href="#"><i class="fa fa-download"></i>Download</a></span>
      </div>
    </div>
  </div>
</template>

<script>
  import Base64Uploader from 'src/components/Inputs/Base64Uploader'
  import b64toBlob from 'b64-to-blob'
  import { Validator } from 'vee-validate';
  
  export default {
    name: 'document-input',
    components: {
      Base64Uploader
    },
    inject: ['$validator'],
    props: {
      document: Object,
      resultView: {type: Boolean, deafult: false },
      canAdd: { type: Boolean, default: false },
      canDelete: { type: Boolean, default: false },
      validationScope: {type: String, default: ''},
      deleteData: Function
    },
    data () {
      return {
        working: false
      }
    },
    computed: {
      uploaded () {
        return this.document.id != null || this.document.data != null
      }
    },
    created() {
      this.$validator.extend('requiredDoc', {
        validate(value, args) {
          return value
        },
        getMessage(field, args) {
          return "This document is required"
        } 
      })
    },
    methods: {
      upload (filename, base64Data) {
        // if(this.document.verificationId) {
        //   this.working = true
        //   this.$api.postDocument(this.document.verificationId, {
        //     name: this.document.name,
        //     data: base64Data
        //   }).then(response => {
        //     this.document.id = response.data.id
        //     this.document.filename = response.data.filename
        //     this.working = false
        //   }).catch(error => {
        //     console.log("Failed to upload document for existing verification " + this.document.verificationId)
        //     this.working = false
        //   })
        // } else {
          this.document.filename = filename
          this.document.data = base64Data
        // }
      },
      download () {
        this.working = true
        if(this.document.data) {
          this.doDownload(b64toBlob(this.document.data, 'application/octet-stream'))
          this.working = false
        } else {
          console.log("ok2")
          var ownerId = this.document.verificationId
          console.log("ok21")
          var ownerType = 'verification'
          console.log("ok22")
          if(!ownerId) {
          console.log("ok23")
            ownerId = this.document.applicationId
            ownerType = 'application'
          }
          this.$api.getDocument(ownerType, ownerId, this.document.id)
            .then(response => {
              this.doDownload(new Blob([response.data], { type: 'application/octet-stream' }))
              this.working = false
            })
            .catch(error => {
              this.working = false
              console.log("Failed to download doc")
              console.log(error)
            })
        }
      },
      doDownload (blob) {
        var filename = this.document.filename;
        if(window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            var link = document.createElement('a');
            var url = window.URL.createObjectURL(blob);
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            setTimeout(function(){
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }, 100); 
        }
      },
      del () {
        this.working = true
        this.deleteData(this.document)
        .then(response => {
          this.document.id = null
          this.filename = null
          this.document.data = null
          this.working = false
          if(!this.document.required) {
            this.$emit('deleted')
          }
        })
        .catch(error => {
          console.log(error)
          this.working = false
        })
      },
      rm () {
        this.$emit('deleted')
      }
    }
  }
</script>
